// Translations
import accessKeys from '../sections/access-keys/translations/de'

// Translation: Account > Integrations (German)
export default Object.freeze({
	header: {
		subtitle: '',
		title: ''
	},
	sections: { accessKeys }
})
